import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  headline: {
    id: 'detailview.grid.headline.recommendation',
    defaultMessage: 'Empfehlungen für dich',
  },
  title: {
    id: 'rde.alternative-products.headline-fallback',
    defaultMessage: 'Ähnliche Artikel',
  },
});
